module.exports = __webpack_public_path__ + "img/9788963010861.bf18fd20.jpg";